module.exports = __webpack_public_path__ + "img/icon-schedule-person.3fc5879f.svg";